const playVideo = (video, button) => {
    video.style.opacity = '1';
    video.setAttribute('tabindex', '-1');
    video.focus();
    video.play().catch(() => {});
    button.hidden = true;
    button.setAttribute('aria-hidden', 'true');
}

const stopVideo = (video, button) => {
    video.blur();
    button.hidden = false;
    button.setAttribute('aria-hidden', 'false');
}

document.addEventListener('DOMContentLoaded', () => {
    const lazyVideoWrappers = document.querySelectorAll('.js-lazy-video');

    lazyVideoWrappers.forEach((wrapper) => {
        const button = wrapper.querySelector('.js-lazy-video-button');
        const video = wrapper.querySelector('.js-lazy-video-media');

        video.setAttribute('tabindex', '-1');

        button.addEventListener('click', () => {
            playVideo(video, button);
        })
    });
});

document.querySelectorAll("video").forEach((video) => {
  video.addEventListener("pause", () => {
    requestAnimationFrame(() => {
        const el = document.activeElement;
        if (el && typeof el.blur === "function") {
            el.blur();
        }
    });
  });
});